"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRate = void 0;
const gs = require("@ivanlog/gs");
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const StateRates_1 = require("./StateRates");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
class StateRate extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageRate, "Rate", true);
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnDelete.onclick = () => this.tryDelete();
        this.page.ctrls.btnToggleDeleted.hide();
        this.page.ctrls.btnToggleDeleted.onclick = () => this._toggleDeleted();
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.Rate)
                    this._rate = args;
                else if (args.id) {
                    this._rate = yield this.lockgui(this.app.api.admin.directory.getRate(args.id));
                    if (!this._rate)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._rate)
                this._urlArgs["id"] = this._rate.id.toString();
            else
                this.page.ctrls.btnDelete.hide();
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl)) {
                this.page.ctrls.btnDelete.hide();
                this.page.ctrls.btnSave.hide();
                this.page.ctrls.form.addClass("no-active");
            }
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.btnDelete.show();
            var ctrl = this.page.ctrls;
            this._setIsDeletedControl(false);
            ctrl.chIsDeleted.el.disabled = true;
            if (this._rate) {
                let fillObj = new models_1.Rate(this._rate);
                fillObj.description_en = this._rate.description.en;
                fillObj.description_de = this._rate.description.de;
                yield ctrl.form.fillFormData(fillObj, true);
                this._setIsDeletedControl(Boolean(this._rate.isDeleted));
                this._updateToggleDeletedButton();
                if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                    ctrl.btnToggleDeleted.show();
                else
                    ctrl.btnToggleDeleted.hide();
                this._updateDeleteButton();
            }
            else
                this.page.ctrls.btnDelete.hide();
            const types = yield this.app.astra.getVehiclesTypes();
            if (types)
                for (const vt of types) {
                    const btn = gs.w(gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName}` }, gs.text.clearHtmlToText(this._formatVehicleTypeLabel(vt))));
                    if (this._rate)
                        if (this._rate.forVehicleTypesId.indexOf(vt.id) >= 0)
                            btn.addClass("selected");
                    btn.setData(gs_1.ItemButton.TagDataValue, vt.id.toString());
                    this.page.ctrls.cbForVehiclesTypes.append(btn);
                }
            yield this.app.astra.refreshRateAreas();
            const areas = yield this.app.astra.getRateAreas();
            if (areas)
                for (const area of areas) {
                    const btn = gs.w(gs.html.tag("button", { class: `${gs_1.ItemButton.TagClassName}` }, area.name));
                    if (this._rate)
                        if (this._rate.rateAreaId == area.id)
                            btn.addClass("selected");
                    btn.setData(gs_1.ItemButton.TagDataValue, area.id.toString());
                    this.page.ctrls.rbRatesArea.append(btn);
                }
            if (!this._rate)
                ctrl.btnToggleDeleted.hide();
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._rate)
                this.setLabel(this.title + ` #${this._rate.id} '${this._rate.name}'`);
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            let rate;
            rate = new models_1.Rate(data);
            rate.description.en = data.description_en;
            rate.description.de = data.description_de;
            rate.rateAreaId = parseInt(this.page.ctrls.rbRatesArea.value);
            if (!rate.rateAreaId) {
                yield new modalCom.DialogOk("Need select rates area").show();
                return;
            }
            rate.forVehicleTypesId = gs.ArrayGS.from(this.page.ctrls.cbForVehiclesTypes.value).select((v) => {
                return parseInt(v);
            });
            if (rate.forVehicleTypesId.length == 0) {
                yield new modalCom.DialogOk("Need select vehicles types area").show();
                return;
            }
            if (this._rate) {
                rate.id = this._rate.id;
                rate = yield this.lockgui(this.app.api.admin.directory.updateRate(this._rate.id, rate));
                if (!rate)
                    return;
                this._rate = rate;
                yield new modalCom.DialogOk("Rate updated").show();
                yield this.fill();
            }
            else {
                rate = yield this.lockgui(this.app.api.admin.directory.createRate(rate));
                if (!rate)
                    return;
                yield new modalCom.DialogOk("Rate created").show();
                yield gs_1.StateGS.Run(StateRates_1.StateRates);
            }
        });
    }
    tryDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._rate)
                return;
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                return;
            if (!this._rate.isDeleted) {
                const responce = yield this.lockgui(this.app.api.admin.directory.deleteRate(this._rate.id));
                if (!responce)
                    return;
                yield new modalCom.DialogOk("Rate deleted").show();
                yield gs_1.StateGS.Run(StateRates_1.StateRates);
                return;
            }
            const restored = yield this.lockgui(this.app.api.admin.directory.restoreRate(this._rate.id));
            if (!restored)
                return;
            this._rate = restored;
            yield this.fill();
            yield new modalCom.DialogOk("Rate restored").show();
        });
    }
    _setIsDeletedControl(value) {
        this.page.ctrls.chIsDeleted.el.checked = value;
        this.page.ctrls.chIsDeleted.el.value = value ? "true" : "false";
    }
    _formatVehicleTypeLabel(vtype) {
        if (!vtype)
            return "Vehicle type";
        const parts = [];
        if (vtype.sizeClass)
            parts.push(vtype.sizeClass);
        if (vtype.size)
            parts.push(`w${vtype.size.width} : l${vtype.size.length} : h${vtype.size.height}`);
        const summary = parts.filter(Boolean).join(" | ");
        return summary || `#${vtype.id}`;
    }
    _updateToggleDeletedButton() {
        const button = this.page.ctrls.btnToggleDeleted;
        if (!button)
            return;
        const desiredState = this._rate ? !this._rate.isDeleted : false;
        button.el.title = desiredState ? "Mark rate as deleted" : "Restore rate";
    }
    _toggleDeleted() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._rate)
                return;
            if (!this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
                return;
            if (!this._rate.isDeleted) {
                const response = yield this.lockgui(this.app.api.admin.directory.deleteRate(this._rate.id));
                if (!response)
                    return;
                this._rate.isDeleted = true;
                this._setIsDeletedControl(true);
                this._updateToggleDeletedButton();
                this._updateDeleteButton();
                yield new modalCom.DialogOk("Rate marked as deleted").show();
                return;
            }
            const restored = yield this.lockgui(this.app.api.admin.directory.restoreRate(this._rate.id));
            if (!restored)
                return;
            this._rate = restored;
            yield this.fill();
            this._setIsDeletedControl(Boolean(this._rate.isDeleted));
            this._updateToggleDeletedButton();
            this._updateDeleteButton();
            yield new modalCom.DialogOk("Rate restored").show();
        });
    }
    _updateDeleteButton() {
        var _a;
        const btn = this.page.ctrls.btnDelete;
        if (!btn)
            return;
        const isDeleted = Boolean((_a = this._rate) === null || _a === void 0 ? void 0 : _a.isDeleted);
        btn.el.title = isDeleted ? "Restore rate" : "Delete rate";
        if (!this._rate || !this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl))
            btn.hide();
        else
            btn.show();
    }
}
exports.StateRate = StateRate;
StateRate.StateName = "rate";
//# sourceMappingURL=StateRate.js.map